import { userPrivacySetting } from '@/Models';
import { consentManager } from './ConsentManager';
import { analyticsPluginName } from '@/Utils/AnalyticsUtility';
import { loadScript } from '@/Utils/ScriptUtility';
import Config from '@/Config';
import Log from '@/Utils/Log';

const sensitiveParams = ['key', 'guestOrderToken'];

function getSanitizedPageLocation() {
    const url = new URL(window.location.href);
    sensitiveParams.forEach(param => url.searchParams.delete(param));
    return url.toString();
}

/**
 * @param {object} analyticsConfig - analyticsConfig from InitialState
 */
export default function googleAnalyticsPlugin(analyticsConfig) {
    const platformName = Config.platformName.toLowerCase();
    const ga4Id = analyticsConfig.googleAnalytics.ga4MeasurementID;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() {
        window.dataLayer.push(arguments);
    };

    let loaded = false;
    const pendingEvents = [];

    function trackEvent({ event, properties }) {
        window.gtag('event', event, properties);
    }

    function flushPendingEvents() {
        pendingEvents.splice(0).forEach(trackEvent);
    }

    consentManager.register(analyticsPluginName.googleAnalytics, userPrivacySetting.analytic, () => {
        window.gtag('consent', 'default', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted',
        });

        loadScript(`https://www.googletagmanager.com/gtag/js?id=${ga4Id}`).catch((error) => {
            Log.warn('[GoogleAnalyticsPlugin] Failed to load gtag.js', error);
        });

        const sanitizedLocation = getSanitizedPageLocation();

        window.gtag('js', new Date());
        window.gtag('set', { page_location: sanitizedLocation });
        window.gtag('config', ga4Id, { groups: platformName, cookie_domain: window.location.hostname, page_location: sanitizedLocation });

        const externalAnalytics = analyticsConfig.externalAnalytics;

        if (externalAnalytics?.googleAnalyticsTrackingId) {
            window.gtag('config', externalAnalytics.googleAnalyticsTrackingId, { groups: 'creator', page_location: sanitizedLocation });
        }

        if (externalAnalytics?.googleAnalyticsMeasurementId) {
            window.gtag('config', externalAnalytics.googleAnalyticsMeasurementId, { groups: 'creator', page_location: sanitizedLocation });
        }

        loaded = true;
        flushPendingEvents();
    });

    return {
        name: analyticsPluginName.googleAnalytics,
        config: analyticsConfig,
        track: () => {},
        trackTo: ({ event, properties }) => {
            const trackPayload = { event, properties };

            if (!loaded) {
                pendingEvents.push(trackPayload);
                return;
            }

            trackEvent(trackPayload);
        },
    };
}
